import React, { useEffect, useState } from 'react';

import cx from 'classnames';
import { colorToString } from '../widget.helper';

import {AnimationComponent} from '../../Animations';
import { HotspotTrigger } from '../../../components/hotspot';
import { getColorsConfig } from '../../../components/AssetViewer/helper/cssHelper';
import { getHotspotWidget } from '../core/hooks';
import styles from './line.module.scss';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';


const LineWidgetComponent = ({className, style, widgetProps, breakpoint}) => {
  const id = get(widgetProps, 'uid');

  const ref = React.useRef();

  const properties = get(widgetProps, `properties.${breakpoint}`);
  const defaultProperties = get(widgetProps, `properties.desktop`, {});
  const type = get(widgetProps, `properties.desktop.type`);
  const shapeAimation = get(widgetProps, `properties.${breakpoint}.animation`, {}) || {};

  const layout = get(defaultProperties, 'layout');
  const fillColor = get(defaultProperties, `fill`);
  const stroke = get(defaultProperties, `stroke`);
  const legacyStyle = get(defaultProperties, `legacyStyle`);
  const hotspotWidget = getHotspotWidget(id);


  let Styles = {
    ...style,
    marginTop: legacyStyle ? '10px': 'unset'
  }

  if (hotspotWidget) {
    Styles = {
      ...Styles,
      cursor: 'pointer'
    }
  }

  return (
    <HotspotTrigger widget={widgetProps} breakpoint={breakpoint} targetRef={ref}>
      <div id={id}
        ref={ref}
        className={cx(className, styles.lineWidget)}
        style={Styles}
        data-widget-id={id}
      >
        <AnimationComponent {...shapeAimation}>
          <Line
            type={type}
            fill={fillColor}
            stroke={stroke}
          />
        </AnimationComponent>
      </div>
    </HotspotTrigger>
  );
}

export const Line = ({ className, type, width, stroke, fill }) => {

  const fillColor = getColorsConfig(fill);
  const strokeColor = getColorsConfig(get(stroke, 'color'));
  const strokeWidth = parseInt(get(stroke, 'width', 0));

  const style = {
    fill: fillColor,
    borderTopColor: strokeColor,
    borderTopWidth: strokeWidth,
    borderTopStyle: type
  }

  return (
    <div className={cx(styles.line, className)} style={style}></div>
  );
}


const lineWidgetEquals = function(prevProps, nextProps){
  const paths = ['className', 'style', 'widgetProps', 'breakpoint'];
  const next = pick(nextProps, paths);
  const previous = pick(prevProps, paths);

  const equals = isEqual(next, previous);
  return equals;
}

export const LineWidget = React.memo(LineWidgetComponent, lineWidgetEquals);
